import { __decorate, __metadata } from "tslib";
import { SerializableObject } from '../../decorators';
import { Orientation } from '../../position';
import { SensorObject } from '../SensorObject';
/**
 * Absolute orientation sensor describes the device's physical orientation in relation to the Earth's reference coordinate system.
 * @category data
 */
let AbsoluteOrientationSensor = class AbsoluteOrientationSensor extends SensorObject {
  constructor(uid, value, frequency, displayName) {
    super(uid, value !== null && value !== void 0 ? value : new Orientation(), frequency, displayName);
  }
};
AbsoluteOrientationSensor = __decorate([SerializableObject(), __metadata("design:paramtypes", [String, Orientation, Number, String])], AbsoluteOrientationSensor);
export { AbsoluteOrientationSensor };